import { render } from "./Badge5.vue?vue&type=template&id=2afbf2c8&scoped=true"
import script from "./Badge5.vue?vue&type=script&lang=js"
export * from "./Badge5.vue?vue&type=script&lang=js"

import "./Badge5.vue?vue&type=style&index=0&id=2afbf2c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afbf2c8"]])

export default __exports__